const SMALL = "small";
const MEDIUM = "default";
const LARGE = "large";

const SIZES = {
  SMALL,
  MEDIUM,
  LARGE,
};

export default SIZES;
